module.exports = __webpack_public_path__ + "img/game1.b69fd5b0.gif";